module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_01@3x-fe38b6bfb6491be044bfc294628769c2.webp";